import cx from "classnames";
import s from "components/_ProductConfigurator/ProductConfiguratorComponent.module.scss";
import { Select } from "components/Select/Select";
import React from "react";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";
import { ImageTabs } from "components/_ProductConfigurator/SubComponents/ImageTabs";
import { TabCard } from "components/InputCards/TabCard";
import { TableCard } from "components/InputCards/TableCard";
import { useTranslate } from "hooks";
import {
  getBodyData,
  getHeadData,
} from "components/_ProductConfigurator/_helpers";
import { InputList } from "./InputList";

export const ProductConfiguratorResultSecondaryView = ({
  isModalView,
  strategyOptions,
  selectedOption,
  handleSelectStrategy,
}) => {
  const { product, productImageList } =
    useProductConfiguratorStore.use.productData() || {};
  const translate = useTranslate();
  const requestParams = useProductConfiguratorStore.use.requestParams();
  const { changeProduct } = useProductConfiguratorStore.use.actions();

  const components = [
    {
      key: "outputsAcoustic",
      component:
        product?.outputsAcoustic?.length > 0 ? (
          <div
            className={cx(
              "d-flex flex-column flex-grow-1 flex-shrink-2 px-4 py-3 bg-white rounded-2",
              { "border border-gray-300": isModalView },
              s.card,
            )}
          >
            <h5 className="mb-4 text20">
              {translate("PRODUCT_CONFIGURATOR_RESULTS")}
            </h5>
            <TabCard
              tabs={[translate("PRODUCT_CONFIGURATOR_REPORT_ACOUSTING_LABEL")]}
              container={[
                <div className="overflow-auto w-100" key="1">
                  <TableCard
                    head={getHeadData(product?.outputsAcoustic)}
                    body={getBodyData(product?.outputsAcoustic)}
                  />
                </div>,
              ]}
            />
          </div>
        ) : null,
      order: isModalView ? 1 : 2,
    },
    {
      key: "inputList",
      component: (
        <div
          className={cx(
            "d-flex flex-column flex-grow-1 flex-shrink-2 px-4 py-3 bg-white rounded-2",
            { "border border-green-300": isModalView },
            s.card,
          )}
        >
          <InputList list={product?.outputs} isValueEditable={false} />
        </div>
      ),
      order: isModalView ? 2 : 3,
    },
    {
      key: "imageTabs",
      component: (
        <div
          className={cx(
            "d-flex flex-column flex-grow-1 flex-shrink-2 w-100 pb-3 bg-white rounded-2",
            { "border border-gray-300": isModalView },
            s.card,
          )}
        >
          <ImageTabs
            images={productImageList?.productImages}
            requestParams={requestParams}
          />
        </div>
      ),
      order: isModalView ? 3 : 1,
    },
  ];

  return (
    <div className="d-flex flex-wrap gap-4 mb-4">
      {product?.inputs?.length > 0 && (
        <div
          className={cx(
            "d-flex flex-column flex-grow-1 flex-shrink-2 px-4 py-3 bg-white rounded-2",
            { "border border-gray-300": isModalView },
            s.card,
          )}
        >
          <div className="border-bottom border-bottom-1 border-color-gray-300">
            <h5 className="mb-4 text20">
              {translate("PRODUCT_CONFIGURATOR_INPUT")}
            </h5>
            <div className="pb-4">
              <h5 className="mb-2_5 font16">
                {translate("PRODUCT_CONFIGURATOR_STRATEGY")}
              </h5>
              <Select
                name={"strategy-select"}
                data-recording-disable={true}
                options={strategyOptions}
                onChange={handleSelectStrategy}
                isDisabled={false}
                value={selectedOption}
                testId={product?.id}
              />
            </div>
          </div>
          <div className="py-2_5">
            <InputList
              list={product?.inputs}
              isValueEditable={true}
              onChange={changeProduct}
              headerStyles="mb-4"
            />
          </div>
        </div>
      )}
      {components
        .sort((a, b) => a.order - b.order)
        .map(({ key, component }) => (
          <React.Fragment key={key}>{component}</React.Fragment>
        ))}
    </div>
  );
};
